module.exports = __webpack_public_path__ + "img/1F1FF-1F1E6.1253109a.svg";